import styled from 'styled-components';
import { Button } from 'antd';

export const MainButton = styled(Button)`
  background-color: white;
  border: 1px solid #2D70BE;
  min-width: 150px;
`;
